<template>
  <div class="yiliao">
    <div class="u-flex u-col-center u-row-between" style="margin-bottom: 26px">
      <!-- <el-dropdown placement="bottom">
        <div
          class="u-flex u-col-center u-row-center"
          style="width: 160px; height: 44px; border: 1px solid #dddddd"
        >
          <img
            style="width: 20px; height: 20px; margin-right: 10px"
            src="../../assets/index1-3.png"
            alt=""
          />
          <span style="font-size: 22px; color: #222222; margin-right: 8px"
            >宏观数据</span
          >
          <i class="el-icon-caret-bottom"></i>
        </div>
        <el-dropdown-menu slot="dropdown">
          <el-dropdown-item>医疗机构</el-dropdown-item>
          <el-dropdown-item>药店</el-dropdown-item>
          <el-dropdown-item>疾病类型</el-dropdown-item>
        </el-dropdown-menu>
      </el-dropdown> -->
      <div class="block">
  <el-cascader
    v-model="select_caidan"
    :options="caidan"
    placeholder="数据分类"
    :show-all-levels="false"
    :props="{ expandTrigger: 'hover' }"
    @change="handleChange22"
    ></el-cascader>
</div>
      <el-input
        placeholder="输入关键字，例如GDP"
        style="width: 540px"
        v-model="keyword"
      >
        <!-- <div slot="prepend" style="height: 100%;background: #F7F7F7;border-radius: 4px 0px 0px 4px;width: 50px;">
					<el-dropdown placement="bottom">
						<span class="el-dropdown-link">
							指标<i class="el-icon-caret-bottom" style="margin-left: 5px;"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item>黄金糕</el-dropdown-item>
							<el-dropdown-item>狮子头</el-dropdown-item>
							<el-dropdown-item>螺蛳粉</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div> -->
        <!-- <div
          slot="prepend"
          class="lianji"
          style="
            height: 100%;
            background: #f7f7f7;
            border-radius: 4px 0px 0px 4px;
            width: 120px;
          "
        >
          <el-cascader placeholder="选择行政区划" v-model="value" :options="options" :props="props" @change="handleChange"></el-cascader>
          <el-select
            v-model="value"
            @change="handleChange"
            placeholder="选择行政区划"
          >
            <el-option
              v-for="(item, index) in options"
              :key="index"
              :label="item.name"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </div> -->
        <div
          @click="getdata"
          slot="suffix"
          class="u-flex u-col-center u-row-center"
          style="
            width: 118px;
            height: 100%;
            background: #51ba85;
            border-radius: 0px 4px 4px 0px;
            color: #fff;
            font-size: 20px;
          "
        >
          <i class="el-icon-search" style="margin-right: 5px"></i>
          <span>搜索</span>
        </div>
      </el-input>
      <el-radio-group v-model="tabPosition1" @change="change">
        <el-radio-button label="1">
          <i class="el-icon-data-board"></i>
          <span>数据表格</span>
        </el-radio-button>
        <el-radio-button label="2">
          <i class="el-icon-data-line"></i>
          <span>图表趋势</span>
        </el-radio-button>
      </el-radio-group>
    </div>
    <div
      class="u-flex u-col-center u-row-between"
      style="
        padding-bottom: 30px;
        border-bottom: 1px solid #eaeaea;
        margin-bottom: 20px;
      "
    >
      <el-select v-model="value1" placeholder="地区" @change="changeselect">
        <el-option
          v-for="(item, index) in options"
          :key="index"
          :label="item.name"
          :value="item.name"
        >
        </el-option>
      </el-select>
      <el-select v-model="value2" placeholder="医院级别" @change="changeselect" v-show="select_caidan.length==0||select_caidan[0]==0">
        <el-option
          v-for="(item, index) in grade"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select v-model="value3" placeholder="医院类型" @change="changeselect" v-show="select_caidan.length==0||select_caidan[0]==0">
        <el-option
          v-for="(item, index) in type"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
      v-show="select_caidan.length==0||select_caidan[0]==0"
        v-model="value4"
        placeholder="公立/民营"
        @change="changeselect"
      >
        <el-option
          v-for="(item, index) in lable"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
      v-show="select_caidan[0]==1"
        v-model="value7"
        placeholder="单体/连锁"
        @change="changeselect"
      >
        <el-option
          v-for="(item, index) in chain"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
      v-show="select_caidan[0]==1"
        v-model="value8"
        placeholder="是否医保定点"
        @change="changeselect"
      >
        <el-option
          v-for="(item, index) in fixed"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      <el-select
      v-show="select_caidan[0]==1"
        v-model="value6"
        placeholder="是否院边药房"
        @change="changeselect"
      >
        <el-option
          v-for="(item, index) in side"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select>
      
      
      <!-- <el-select
        v-model="value5"
        placeholder="智能排序"
        @change="changeselect"
      >
        <el-option
          v-for="(item, index) in intelligence"
          :key="index"
          :label="item"
          :value="item"
        >
        </el-option>
      </el-select> -->
    </div>
    <div class="u-flex u-row-between">
      <el-radio-group v-model="tabPosition1" @change="change">
      <el-radio-button label="1">
        <i class="el-icon-data-board"></i>
        <span>字段数据</span>
      </el-radio-button>
      <el-radio-button label="2">
        <i class="el-icon-data-line"></i>
        <span>图表趋势</span>
      </el-radio-button>
    </el-radio-group>
    <ul class="u-flex topui" v-show="tabPosition1 == 1">
      <li class="topli topli1" :class="{'select11':searchCurrent==index}" v-for="(item,index) in searchList" :key="index" @click="searchClick(index)">{{item}}<span style="margin-left:5px" v-show="index!=0">↓</span></li>
      <!-- <li class="topli topli1">诊疗人次 ↓</li>
      <li class="topli topli1">床位数 ↓</li>
      <li class="topli topli1">医师数 ↓</li> -->
      <li class="topli other" style="border-right:none;position: relative;">
      <div :class="{'select11':searchCurrent2!=null}">
        {{searchCurrent2==null?'其他排序':searchList2[searchCurrent2]}}<span style="margin-left:5px" v-show="searchCurrent2!=null">↓</span><i class="el-icon-arrow-down"></i>
      </div>
      <div class="otherSelect">
        <div v-for="(item,index) in searchList2" :class="{'select11':searchCurrent2==index}"  :key="index" @click="searchClick2(index)">{{item}}<span style="margin-left:5px" >↓</span></div>
        <!-- <div>医疗支出 ↓</div>
        <div>住院手术人数 ↓</div>
        <div>出院人数 ↓</div> -->
      </div>
      </li>
    </ul>
    </div>
    <div  v-show="tabPosition1 == 1">
		<div
      style="
        width: 1320px;
        border-radius: 4px;margin-top: 20px;padding: 15px 0;border-bottom: 1px solid #f0f0f0;
      " class="u-flex"
	  v-for="(item,index) in tableData" :key="index" @click="toInfo(item)"
    >
    <img :src="img" alt="" style="width:170px;height:128px;margin-right:20px">
	<div style="flex:1">
    <div style="font-size:18px" v-if="select_caidan.length==0||select_caidan[0]==0">{{item.name}}<span style="margin-left:12px;font-size:14px;background-color:#51BA85;color:#fff;padding: 0 6px;">{{item.h_type}}</span></div>
    <div style="font-size:18px" v-else>{{item.pharmacy_name}}<span style="margin-left:12px;font-size:14px;background-color:#51BA85;color:#fff;padding: 0 6px;">{{item.p_type}}</span></div>
	<div style="font-size:14px;color:#777777;margin-top:12px">
		<span v-show="item.grade">{{item.grade}}</span><span style="margin:0 10px"  v-show="item.grade">|</span><span  v-show="item.lable">{{item.lable}}</span><span style="margin:0 10px"   v-show="item.lable">|</span><span >{{item.address}}</span>
	</div>
  <div style="margin-top:12px" v-if="item.name&&item.key_departments">重点科室:{{item.key_departments}}</div>
	<!-- <div style="font-size:14px;color:#444444;margin-top:12px">
		<span style="color: #000;">经营范围：</span>{{item.business}}
	</div> -->
  </div>
	</div>
	<div style="text-align:center;margin-top: 34px;">
		<el-pagination
		:page-size="3"
		:current-page.sync="current"
		@current-change="handleCurrentChange"
  background
  layout="prev, pager, next"
  :total="total">
</el-pagination>
	</div>
	</div>
    <!-- <div class="u-flex u-col-center u-row-between u-flex-wrap" style="padding: 30px 0px;" v-show="tabPosition1 == 1">
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">卫生人员</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.number}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">卫生技术人员</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.menzhen}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">执业[助理]医师</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.zhuyuan}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">执业医师</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.chuyuan}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">注册护士</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.yiliao}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">药师</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.shouru}}</span>
			</div>
			<div class="u-flex-col u-col-center" style="margin: 0 40px 20px 40px;">
				<span style="line-height:50px;text-align: center;background: #51BA85;border-radius: 0px 0px 4px 4px;width: 220px;">技师</span>
				<span style="line-height:50px;text-align: center;background: #F4F4F4;border-radius: 2px 2px 0px 0px;width: 220px;">{{datainfo.yaopin}}</span>
			</div>
			<div style="width: 220px;margin: 0 40px;"></div>
			<div style="width: 220px;margin: 0 40px;"></div>
		</div> -->
    <div
      class="u-flex u-col-center u-row-between u-flex-wrap"
      style="padding: 50px 0 100px 0"
      v-show="tabPosition1 == 2"
    >
      <div style="width: 25%; height: 225px" id="bing1"></div>
      <div style="width: 25%; height: 225px" id="bing2"></div>
      <div style="width: 25%; height: 225px" id="bing3"></div>
      <div style="width: 25%; height: 225px" id="bing4"></div>
      <div style="width: 25%; height: 225px" id="bing5"></div>
      <div style="width: 25%; height: 225px" id="bing6"></div>
      <div style="width: 25%; height: 225px" id="bing7"></div>
      <div style="width: 25%; height: 225px" id="bing8"></div>
    </div>
    <el-dialog :visible.sync="dialogVisible" width="900px;">
      <div>
        <el-input
          placeholder="输入关键字，例如GDP"
          style="width: 540px; margin-bottom: 20px"
          v-model="keyword"
        >
          <!-- <div slot="prepend" style="height: 100%;background: #F7F7F7;border-radius: 4px 0px 0px 4px;width: 100px;">
						<el-dropdown placement="bottom">
							<span class="el-dropdown-link">
								行政区划<i class="el-icon-caret-bottom" style="margin-left: 5px;"></i>
							</span>
							<el-dropdown-menu slot="dropdown">
								<el-dropdown-item>黄金糕</el-dropdown-item>
								<el-dropdown-item>狮子头</el-dropdown-item>
								<el-dropdown-item>螺蛳粉</el-dropdown-item>
							</el-dropdown-menu>
						</el-dropdown>
					</div> -->
          <div
            slot="prepend"
            class="lianji"
            style="
              height: 100%;
              background: #f7f7f7;
              border-radius: 4px 0px 0px 4px;
              width: 120px;
            "
          >
            <el-cascader
              placeholder="选择行政区划"
              v-model="value"
              :options="options"
              :props="props"
              @change="handleChange"
            ></el-cascader>
          </div>
          <div
            slot="suffix"
            @click="getdata()"
            class="u-flex u-col-center u-row-center"
            style="
              width: 118px;
              height: 100%;
              background: #51ba85;
              border-radius: 0px 4px 4px 0px;
              color: #fff;
              font-size: 20px;
            "
          >
            <i class="el-icon-search" style="margin-right: 5px"></i>
            <span>搜索</span>
          </div>
        </el-input>
        <el-checkbox-group
          v-model="checkedCities"
          @change="handleCheckedCitiesChange"
        >
          <el-checkbox v-for="city in cities" :label="city" :key="city">{{
            city
          }}</el-checkbox>
        </el-checkbox-group>
        <el-table
          :data="tableData"
          style="width: 100%; background-color: #f6f6f6"
        >
          <el-table-column type="selection" width="50"></el-table-column>
          <el-table-column prop="id" label="序号" width="60"></el-table-column>
          <el-table-column prop="A1" label="年份"></el-table-column>
          <el-table-column prop="A2" label="行政区号"></el-table-column>
          <el-table-column prop="A3" label="省"></el-table-column>
          <el-table-column prop="L2" label="床位数"></el-table-column>
          <el-table-column prop="A6" label="职业医师数量"></el-table-column>
          <!-- <el-table-column prop="lale" label="公里民营" width="90"></el-table-column>
					<el-table-column prop="number" label="床位数" width="90"></el-table-column> -->
        </el-table>
        <!-- <div style="padding-top: 20px;" class="u-flex u-row-right">
					<el-pagination background layout="prev, pager, next" :total="1000"></el-pagination>
				</div> -->
      </div>
    </el-dialog>
	
  </div>
</template>

<script>
import * as echarts from "echarts";
export default {
  data() {
    return {
      list:[],
		current:1,
      tabPosition: "1",
      tabPosition1: "1",
      options: [],
      props: {
        label: "name",
        value: "id",
      },
      value: "",
      dialogVisible: false,
      checkedCities: [],
      cities: ["A", "B", "C"],
      tableData: [],
      sheng: "",
      shi: "",
      qu: "",
      keyword: "",
      value1: "",
      value2: "",
      value3: "",
      value4: "",
      value5:"智能",
      value6:'',
      value7:'',
      value8:'',
      value9:'',
      grade: [],
      lable: [],
      side: [],
      intelligence:[],
      type: [],
      chain: [],
      fixed: [],
      datainfo: {},
      img:'',
	  total:0,
      searchList:['智能','诊疗人次','床位数','医师数'],
      searchList2:['医疗收入','医疗支出','住院手术人数','出院人数'],
      searchCurrent:0,
      searchCurrent2:null,
       select_caidan: [],
        caidan: [{
          value: '0',
          label: '医院',
          children: [
            {
            value: '0',
            label: '医院',
            
            },
            {
            value: '1',
            label: '妇幼保健院',
            
            }, {
            value: '2',
            label: 'CHC',
            
          }, {
            value: '3',
            label: '门诊部',
            
          }, {
            value: '4',
            label: '诊所',
            
          }, {
            value: '5',
            label: '卫生院',
            
          }]
        
          },{
          value: '1',
          label: '药店',
          children: [
            {
            value: '0',
            label: '零售药店',
            
            },
            {
            value: '1',
            label: 'DTP药店',
            
            }]
        
          },{
          value: '2',
          label: '疾病类型'
          }]

    };
  },
  created() {
	this.getdata()
    this.getcity();
    this.getlabel();
    this.changeselect();
    this.getHospitalInfo()
      this.getMedicalInfo()
  },
  
  methods: {
    handleChange22(newVal){
      this.searchCurrent2=null
        this.searchCurrent=0
        if(newVal.length==0||newVal[0]==0){
          this.searchList=['智能','诊疗人次','床位数','医师数']
          this.searchList2=['医疗收入','医疗支出','住院手术人数','出院人数']
          this.tableData=[]

        this.getdata()
        }
        if(newVal[0]==1){
          this.searchList=['智能','参保员工人数','相关建筑距离']
          this.searchList2=['营业收入','主营业务收入','资产总额','负债总额','利润总额','纳税总额']
          if(newVal[1]==0){
          this.value9='零售药店'
          console.log(0,this.value9);

        }
        if(newVal[1]==1){
          this.value9='DTP药店'
        }
        this.tableData=[]

        this.getdata()
        }
        
      
    },
    searchClick(index){
      if(this.searchCurrent!=index){
        this.searchCurrent2=null
        this.searchCurrent=index
        this.value5=this.searchList[this.searchCurrent]
        this.current=1
        this.getdata()
      }
    },
     searchClick2(index){
      if(this.searchCurrent2!=index){
        this.searchCurrent=null
        this.searchCurrent2=index
        this.value5=this.searchList2[this.searchCurrent2]
        this.current=1

        this.getdata()

      }
    },
	toInfo(item){
		this.$router.push({
					path: "/hospitalInfo",
					query:{
						item:JSON.stringify(item)
					}
				})
	},
	handleCurrentChange(e){
		this.getdata()
	},
    getlabel() {
      this.$http({
        url: "/api/Bigdata/hospital_array",
      }).then((res) => {
        this.grade = res.data.grade;
        this.lable = res.data.lable;
        this.side = res.data.side;
        this.intelligence=res.data.intelligence;
        this.type = res.data.type;
        this.chain = res.data.chain;
        this.fixed = res.data.fixed;
      });
    },
    changeselect() {
      this.$http({
        url: "/api/Bigdata/hospital_show",
        data: {
          grade: this.value2,
          lable: this.value3,
          type: this.value4,
          sheng: this.value1=='全部'?'':this.value1,
        },
      }).then((res) => {
        this.datainfo = res.data;
      });
    },
    getdata() {
    //   this.dialogVisible = true;
    //   this.$http({
    //     url: "/api/Bigdata/hospital",
    //     data: {
    //       sheng: this.sheng,
    //       shi: this.shi,
    //       qu: this.qu,
    //       name: this.keyword,
    //     },
    //   }).then((res) => {
    //     if (res.code == 1) {
    //       this.tableData = res.data;
    //     } else {
    //       this.$message.error(res.msg);
    //     }
    //   });
	// this.dialogVisible = true;
  if(this.select_caidan.length==0||this.select_caidan[0]==0){
    this.$http({
        url: "/api/Bigdata/new_hospital",
        data: {
          province: this.value1=='全部'?'':this.value1,
          grade: this.value2,
          type: this.value3,
		  lable:this.value4,
      intelligence:this.value5,
		  name:this.keyword,
		  page:this.current
        },
      }).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.data;
		  this.total=res.data.total
      this.img='http://jainzhi.zhousi.hdlkeji.com/upload/f32e16bc91e02043/813af0f44ca4cedb.png'
        } else {
          this.$message.error(res.msg);
        }
      });
  }else{
    this.$http({
        url: "/api/Bigdata/pharmacy",
        data: {
          chain:this.value7,
          fixed:this.value8,
          side:this.value6,
          province: this.value1=='全部'?'':this.value1,
      intelligence:this.value5,
		  name:this.keyword,
		  page:this.current,
      p_type:this.value9
        },
      }).then((res) => {
        if (res.code == 1) {
          this.tableData = res.data.data;
		  this.total=res.data.total
      this.img='http://jainzhi.zhousi.hdlkeji.com/upload/ee077293df01dab8/94346e60a217d707.png'
        } else {
          this.$message.error(res.msg);
        }
      });
  }
      
    },
    handleChange(e) {
      console.log(e);
      this.sheng = e[0]=='全部'?'':e[0]
      // this.shi = e[1]
      // this.qu = e[2]
    },
    getcity() {
      this.$http({
        url: "/api/Bigdata/sheng",
      }).then((res) => {
        if (res.code == 1) {
          this.options = [{id:0,name:"全部",pid:0,shortname:"全部"},...res.data];
        } else {
          this.$message.error(res.msg);
        }
      });
    },
    handleCheckedCitiesChange() {},
    change(e) {
      if (e == 2) {
        this.setbing();
      }
    },
    getHospitalInfo(){
			this.$http({
					url: '/api/Bigdata/new_hospital_show',
					
				}).then(res => {
					if (res.code == 1) {
						this.list=res.data
					} else {
						
					}
				})
		},
		getMedicalInfo(){
			this.$http({
					url: '/api/Bigdata/pharmacy_show',
					
				}).then(res => {
					if (res.code == 1) {
						this.list=res.data
					} else {
						
					}
				})
		},
    setbing() {
      if(this.select_caidan.length==0||this.select_caidan[0]==0){
        
        var arr = [
        "执业医师数量",
        "床位数",
        "急诊人数",
        "出院人数",
        "住院手术人数",
        "医疗收入",
        "医疗支出",
      ];
		}else{
      
			var arr = [
        "营业收入",
        "主营业务收入",
        "资产",
        "负债",
        "利润",
        "净利润",
        "纳税",
      ];
		}
    

      arr.forEach((val, key) => {
        var chartDom = document.getElementById(`bing${key + 1}`);
        var myChart = echarts.init(chartDom);
        myChart.setOption({
          // legend: {},
          tooltip: {},
          graphic: {
            type: "text",
            left: "center",
            bottom: "0",
            style: {
              text: val,
              textAlign: "center",
              fill: "#222",
              fontSize: 14,
              fontWeight: 400,
            },
          },
          series: [
            {
              name: val,
              type: "pie", // 设置图表类型为饼图
              radius: "45%", // 饼图的半径，外半径为可视区尺寸（容器高宽中较小一项）的 55% 长度。
              label: {
                show: false,
              },
              itemStyle: {
                normal: {
                  color: function (colors) {
                    var colorList = ["#4B87FF", "#22D66C", "#5D7092"];
                    return colorList[colors.dataIndex];
                  },
                },
              },
              data: [
                // 数据数组，name 为数据项名称，value 为数据项值
                {
                  value: this.list[key].zongshu,
                  name: "总数",
                },
                {
                  value: this.list[key].tiaojian,
                  name: "统计",
                }
              
              ],
            },
          ],
        });
      });
    },
  },
};
</script>

<style lang="scss">

.other:hover .otherSelect{
  display: block;
}
.otherSelect{
  display: none;
  position: absolute;
    width: 92px;
    padding: 0 0 5px 0;
    top: 17px;
    left: -2px;
    background-color: #fff;
    border: solid 1px #eee;
    div{
      height: 26px;
      line-height: 26px;
    }
}
.select11{
  color: #f63!important;

}
.otherSelect div:hover{
  cursor: pointer;
  color: #f63;
}
li{
  list-style: none;
}
.topli{
  text-align:center;padding: 0 15px;font-size: 12px;color: #333;border-right: 1px solid #e0e0e0;position: relative;
  
}
.topli1:hover{
  cursor: pointer;
  color: #f63;
}
.yiliao {
  width: 1400px;
  // height: 840px;
  background: #ffffff;
  margin: 20px auto;
  padding: 30px 40px;

  .el-input__suffix {
    right: 0;
  }
  .lianji {
    .el-cascader {
      line-height: 38px;
      height: 38px;
    }

    .el-input__inner {
      border: none;
      line-height: 38px;
      height: 38px;
      background-color: #f7f7f7;
    }
  }
}
</style>
